import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the Filter pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'filter',
  pure: false
})
export class FilterPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(list: any[], search: string, field: string = '*'): any[] {

    if (!list || !search) {
      return list;
    }

    field = field || '*';
    if (field === '*') {
      return list.filter((it: any) => {
        const item = Object.assign({}, it);
        delete item._id;
        delete item._styles;
        return !!JSON.stringify(item).toLowerCase().match(new RegExp(search.toString().toLowerCase()));
      });
    }

    return list.filter((item: any) => {
      if (!item[field]) {
        return false;
      }

      return !!item[field].toString().toLowerCase().match(new RegExp(search.toString().toLowerCase()))
    });
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/shared/pipes/filter.pipe.ts